'use client'

import { useQuery } from '@tanstack/react-query'
import { getContactFacets } from '@/services/contacts'

export const contactFacetsKey = ['contacts', 'facets'] as const

const EMPTY: string[] = []

/**
 * Opções dos seletores de origem (país/DDD) vindas do back.
 *
 * Chave SEM search e SEM filtros de propósito: as facets descrevem o universo do
 * tenant, não o recorte na tela. Derivá-las da listagem — paginada e já filtrada —
 * é o que fazia o select colapsar pro único país selecionado.
 */
export function useContactFacets() {
  const query = useQuery({
    queryKey: contactFacetsKey,
    queryFn: () => getContactFacets(),
    // universo do tenant muda com cadastro de contato, não com navegação
    staleTime: 5 * 60_000,
  })
  return {
    ...query,
    countries: query.data?.country_codes ?? EMPTY,
    ddds: query.data?.area_codes ?? EMPTY,
  }
}
